import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import {GroupSortField as GroupSortFields} from '../typedef';

import type {GroupSortField, GroupsTabFilters} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const groupsTabStateSlice = getCachedTableStateSlice<
    undefined,
    GroupSortField,
    GroupsTabFilters
>('groupsTabState', GroupSortFields.GROUP_NAME);

export const groupsTabStateActions = groupsTabStateSlice.actions;
export const groupsTabStateSelector:
CachedTableStateSelector<undefined, GroupSortField, GroupsTabFilters>
    = state => state.accountPage.tabs.usersAndGroups.accountGroups.state;
